module.exports = __webpack_public_path__ + "img/ic_phone_nor-1.7da3ff95.svg";